export default "__VITE_ASSET__lgQYGv5W__"